import { useCallback, useEffect, useState } from 'react';

const readBoolean = (key: string, defaultValue: boolean): boolean => {
  try {
    const raw = localStorage.getItem(key);
    if (raw === 'true') return true;
    if (raw === 'false') return false;
    return defaultValue;
  } catch {
    return defaultValue;
  }
};

export const usePersistedBoolean = (
  key: string,
  defaultValue: boolean,
): [boolean, (next: boolean) => void] => {
  const [value, setValueState] = useState<boolean>(() => readBoolean(key, defaultValue));

  useEffect(() => {
    setValueState(readBoolean(key, defaultValue));
  }, [key, defaultValue]);

  const setValue = useCallback(
    (next: boolean) => {
      setValueState(next);
      try {
        localStorage.setItem(key, next ? 'true' : 'false');
      } catch {
        // ignore quota / private-mode errors
      }
    },
    [key],
  );

  return [value, setValue];
};
